import { Injectable } from "@angular/core";
import { ApiService } from "../../../shared/services/api/api.service";
import { Observable } from "rxjs";
import { IInstituation } from "../models/instituation";


@Injectable({
  providedIn:'root'
})

export class InstituationService{

  constructor(private readonly apiService:ApiService){}

  getList() {
    return this.apiService.get<IInstituation[]>('instituation')
  }

  create(menu: any): Observable<any> {
    return this.apiService.post<any>('instituation/create', menu)
  }

  update(menu: any): Observable<any> {
    return this.apiService.patch<any>('instituation/update', menu);
  }
}
